import { Button } from '../primitives/button.js'
import { Resize } from '@tunasong/icons'
import type { EmbedSize, Sizable } from '@tunasong/models'
import { EditorQueries, useEditor } from '@tunasong/plugin-lib'
import type { RenderMenuItemProps } from '@tunasong/plugin-lib'
import { isCoreElement } from '@tunasong/schemas'
import type { Entity } from '@tunasong/schemas'
import type { FC } from 'react'
import invariant from 'tiny-invariant'
import { ListItem, ListItemIcon, ListItemText, ButtonGroup } from '../primitives/index.js'
import styles from './sizer-action.module.css'

const sizeOptions: { value: EmbedSize; label: string }[] = [
  { value: 'small', label: 'Small' },
  { value: 'medium', label: 'Medium' },
  { value: 'large', label: 'Large' },
]

export const SizerAction: FC<RenderMenuItemProps> = props => {
  const { element, onClose } = props
  const editor = useEditor({ allowNull: true })

  if (!editor) {
    return null
  }
  const { size: currentSize = 'medium' } = element as Sizable<Entity>

  const handleSize = (size: EmbedSize) => () => {
    invariant(isCoreElement(element), `element is not a CoreElement`)
    EditorQueries.updateElement(editor, element, { size })
    onClose?.()
  }

  return (
    <ListItem>
      <ListItemIcon>
        <Resize />
      </ListItemIcon>
      <ListItemText>
        <ButtonGroup size="small" role="group" aria-label="Block size">
          {sizeOptions.map(({ value, label }) => (
            <Button
              key={value}
              variant={currentSize === value ? 'contained' : 'outlined'}
              aria-pressed={currentSize === value}
              onClick={handleSize(value)}
              className={styles.button}
            >
              {label}
            </Button>
          ))}
        </ButtonGroup>
      </ListItemText>
    </ListItem>
  )
}

export default SizerAction
